const cartReducer = (state, { type, payload }) => {
    let isProduct;
    let product;
    console.log(payload, "Checking the payload");
    switch (type) {
        case 'ADD_PRODUCT':
            isProduct = state.filter(element => element.id === payload.id)

            if (isProduct.length === 0) {
                product = { count: 1, ...payload }

                return [
                    ...state,
                    product
                ]
            } else {


                state = state.map((ele, index) => {
                    if (ele === isProduct[0]) {
                        return ({
                                ...ele,
                                count: ele['count'] + 1
                            }

                        )

                    } else {
                        return (ele)
                    }

                })


                return [
                    ...state
                ]
            }

        case 'REMOVE_PRODUCT':
            isProduct = state.filter(element => element.id === payload.id)


            state = state.map((ele, index) => {
                if (ele === isProduct[0] && ele['count'] > 1) {
                    return ({
                            ...ele,
                            count: ele['count'] - 1
                        }

                    )

                } else if (ele === isProduct[0]) {
                    state.splice(index, 1)
                } else {

                    return ele;
                }

            })


            return [
                ...state
            ]

        case 'Express_Product':
            product = { count: 1, ...payload }
            return [
                product
            ]

        case 'START_SHOPPING':
            product = { count: 1, ...payload }
            return [

            ]







        default:
            return state
    }
}

export default cartReducer